import { createIcon } from '@chakra-ui/react'
const Logo = createIcon({
  displayName: 'LogoTsx',
  viewBox: '0 0 27.505 27.505',
  d: 'M149.753,36.007V36l-11-11L125,38.741l1.94,1.945.81-.816V52.5h9.626V47h2.75v5.5h9.626V39.9l.8.8,1.947-1.945ZM147,49.754h-4.126v-5.5h-8.251v5.5H130.5V37.12l8.237-8.238L147,37.146Z'
})

export default Logo
